import { Component, OnInit, Type } from "@angular/core";
import { AccountService, AuthService, HttpCommonService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { TimeInterval, DashboardModel } from "./models/dashboard.model";
import * as moment from "jalali-moment";
import { ContactUsModalComponent } from "./contact-us-modal/contact-us-modal.component";
import { finalize, take } from "rxjs/operators";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { LicenseInformation } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "ngx-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  currentInformation: LicenseInformation;
  hasBranch: boolean;

  public isLoading = true;
  inputEditorform: Type<any>;
  public timeInterval: TimeInterval = "Daily";
  public model: DashboardModel;
  public TimeIntervalLabels = {
    Daily: [
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.Today"),
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.Yesterday"),
    ],
    Weekly: [
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.Weekend"),
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.LastWeek"),
    ],
    Monthly: [
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.Month"),
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.LastMonth"),
    ],
    Yearly: [
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.Year"),
      this.translate.instant("ClientApp.FrontOffice.Review.Dashboard.LastYear"),
    ],
  };
  today: string;
  public logoFilePath: string;
  isMultiBranch: boolean;
  BranchQuantitySaleComparisonSummary: boolean;
  BranchAmountSaleComparisonSummary: boolean;

  constructor(
    private accountService: AccountService,
    public dialogService: SimpleModalService,
    private sts: ShowToastrService,
    private httpCommonService: HttpCommonService,
    private translate: TranslateService //تا اینجا انجام شد
  ) {
    this.inputEditorform = ContactUsModalComponent;
  }

  ngOnInit(): void {
    this.currentInformation = this.accountService.authService?.currentInformation();
    this.load(this.timeInterval);
    this.setToday();
    this.isMultiBranch =
      (this.accountService.authService.currentInformation().BranchingAdvancedEnabled ||
        this.accountService.authService.currentInformation().BranchingLightEnabled ||
        this.accountService.authService.currentInformation().RestaurantCallCenter) &&
      this.accountService.authService.currentBranch?.AccessToAllBranches;
    this.hasBranch =
      this.currentInformation.BranchingAdvancedEnabled ||
      this.currentInformation.BranchingLightEnabled ||
      this.currentInformation?.RestaurantCallCenter;
    this.branchComparisonSalePermission();
  }

  private setToday() {
    this.today = moment().locale("fa-IR").format("dddd، jDD jMMMM jYYYY").toString();
  }
  branchComparisonSalePermission() {
    if (this.accountService.userHasPermission(`RestaurantSale:Dashboard`, "ReadBranchSaleAmount")) {
      this.BranchAmountSaleComparisonSummary = true;
    }
    if (this.accountService.userHasPermission(`RestaurantSale:Dashboard`, "ReadBranchSaleQuantity")) {
      this.BranchQuantitySaleComparisonSummary = true;
    }
  }
  load(timeInterval: TimeInterval) {
    this.isLoading = true;
    this.timeInterval = timeInterval;
    this.httpCommonService
      .get(`Dashboard/Load/?TimeInterval=${timeInterval}`)
      .pipe(take(1))
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((model: DashboardModel) => {
        this.model = model;
        this.logoFilePath = model.Info.LogoFilePath;
      });
  }

  openContactUsModal() {
    this.dialogService.open(this.inputEditorform, {}, { autoFocus: true, closeOnClickOutside: false, closeOnEscape: true });
  }
}
